/**
 * SCH-5.9 — sync-health metrics types.
 *
 * `successRate` and `avgDurationMs` are `number | null` on purpose, and the null is not laziness
 * about missing data. A gap-filled bucket — a day inside the range with no sync runs in it — has
 * no success rate to report. Zero would mean "everything failed", which is a different and much
 * more alarming claim than "nothing ran". recharts breaks a line on null, which is exactly right.
 *
 * `projectsChanged` and `authFailures` are plain numbers: in an empty bucket they genuinely are 0.
 */

export type SyncMetricsRange = '7d' | '30d' | '90d';
export type SyncMetricsBucketSize = 'day' | 'week';

export const SYNC_METRICS_RANGES: readonly SyncMetricsRange[] = ['7d', '30d', '90d'];

export interface SyncMetricsPoint {
  bucketStart: string;
  totalRuns: number;
  successfulRuns: number;
  /** null when the bucket contains no runs — NOT zero. */
  successRate: number | null;
  /** null when the bucket contains no runs — NOT zero. */
  avgDurationMs: number | null;
  projectsChanged: number;
  authFailures: number;
}

export interface SyncMetricsResponse {
  range: SyncMetricsRange;
  bucket: SyncMetricsBucketSize;
  data: SyncMetricsPoint[];
}

/** AC4: one tenant's rollup in the superadmin cross-tenant view. */
export interface TenantSyncHealth {
  tenantId: string;
  totalRuns: number;
  successfulRuns: number;
  successRate: number | null;
  sparkline: SyncMetricsPoint[];
}

export interface CrossTenantSyncMetricsResponse {
  range: SyncMetricsRange;
  data: TenantSyncHealth[];
}

export interface SyncMetricsError {
  code: string;
  message: string;
}

export interface SyncMetricsResult<T> {
  data: T | null;
  error: SyncMetricsError | null;
}
